var _linearGradient, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgTrim = function SvgTrim(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "trim_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: -911.234,
    y1: 565.796,
    x2: -910.829,
    y2: 565.391,
    gradientTransform: "matrix(64 0 0 -64 58339 36231)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#517df8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#trim_svg__a)",
    d: "M57 66H9c-4.962 0-9-4.037-9-9V9c0-4.962 4.038-9 9-9h48c4.963 0 9 4.038 9 9v48c0 4.963-4.037 9-9 9zM9 2C5.14 2 2 5.14 2 9v48c0 3.859 3.14 7 7 7h48c3.859 0 7-3.141 7-7V9c0-3.86-3.141-7-7-7H9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0C13",
    d: "M36.773 33.333l10.825-8.097a1 1 0 00-1.197-1.602l-11.297 8.45-5.415-4.05a6.152 6.152 0 00.696-2.841c0-3.415-2.778-6.193-6.193-6.193S18 21.778 18 25.193s2.778 6.192 6.192 6.192a6.167 6.167 0 004.301-1.747l4.94 3.695-4.973 3.72a6.167 6.167 0 00-4.269-1.718 6.199 6.199 0 00-6.192 6.193c0 3.414 2.778 6.192 6.192 6.192s6.193-2.778 6.193-6.192c0-1.04-.261-2.02-.716-2.882l5.434-4.065 11.297 8.449a1.001 1.001 0 001.198-1.601l-10.824-8.096zm-12.581-3.948A4.197 4.197 0 0120 25.193 4.198 4.198 0 0124.192 21a4.198 4.198 0 014.193 4.193 4.198 4.198 0 01-4.193 4.192zm0 16.336A4.197 4.197 0 0120 41.529a4.198 4.198 0 014.192-4.193 4.198 4.198 0 014.193 4.193 4.198 4.198 0 01-4.193 4.192z"
  })));
};
export default SvgTrim;